import { getAll} from "../../fetchs/get";
import { sessionEnd } from "../../redux/actions";

export default async function getForecastsData (
    setForecastsData : Function,
    token : string | undefined,
    dispatch : Function,
    setError : Function
) {
    if(token){
        getAll(token, '/forecast', setForecastsData, 
            () => {
                dispatch(sessionEnd());
            }, setError
        )
    }
}